import { Component, Input, OnInit } from '@angular/core';
import { TicketReservationPlugin } from 'projects/qcloud-models/reservation-plugin/ticket-reservation-plugin';

@Component({
  selector: 'app-reservation-confirm',
  templateUrl: './reservation-confirm.component.html',
  styleUrls: ['./reservation-confirm.component.scss']
})
export class ReservationConfirmComponent implements OnInit {

  @Input() ticketReservation: TicketReservationPlugin;
  @Input() categoryName: string;
  @Input() showConfirmation: boolean;
  @Input() confirmationTime: number;
  displayReservationTime: Date | string;

  constructor() {
  }

  ngOnInit(): void {
    if (this.isDateType()) {
      this.displayReservationTime = new Date(this.ticketReservation.reservationTime.getFullYear(),
        this.ticketReservation.reservationTime.getMonth(), this.ticketReservation.reservationTime.getDate(),
        this.ticketReservation.reservationTime.getUTCHours(), this.ticketReservation.reservationTime.getMinutes());
    }
    else {
      this.displayReservationTime = this.ticketReservation.reservationTime;
    }
  }

  isDateType(): boolean {
    return typeof this.ticketReservation.reservationTime.getMonth === 'function';
  }
}
